import {json} from '../core/data-source/json.mapper';

export class TerritoryGroupRecord {
    @json()
    aocId: number;
    @json()
    id: number;
    @json()
    name: string;
}
